require('./all')

//scss
import '../../scss/site/services.scss'
//

const bootstrap_collapse = require('bootstrap/js/dist/collapse');

var nav = document.getElementById('nav-menu-box')

nav.addEventListener('show.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.add('show')
})

nav.addEventListener('hide.bs.collapse', function () {
    nav.parentElement.parentElement.parentElement.classList.remove('show')
})

